import { ASSETS } from "@/lib/assets";
import { StoreBadges } from "@/components/landing/StoreBadges";

const Phone = ({ src, alt, className = "", testId }) => (
  <div
    data-testid={testId}
    className={`overflow-hidden rounded-[2.2rem] border-[6px] border-[var(--ink)] bg-[var(--ink)] shadow-[0_30px_60px_-18px_rgba(46,42,36,0.45)] ${className}`}
  >
    <img src={src} alt={alt} className="block h-full w-full object-cover" loading="eager" />
  </div>
);

export const Hero = () => (
  <section className="relative overflow-hidden">
    <div className="pointer-events-none absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full bg-[var(--sage-light)] opacity-60 blur-3xl" />
    <div className="pointer-events-none absolute -left-32 top-72 h-[360px] w-[360px] rounded-full bg-[var(--peach)] opacity-60 blur-3xl" />

    <div className="relative mx-auto grid max-w-6xl items-center gap-16 px-6 pb-24 pt-20 lg:grid-cols-[1.1fr_0.9fr] lg:pb-32 lg:pt-28">
      <div>
        <span
          data-testid="hero-eyebrow"
          className="rise inline-flex items-center gap-2 rounded-full border border-[var(--sage)] bg-[var(--sage-light)] px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.16em] text-[var(--olive-deep)]"
        >
          <span className="h-1.5 w-1.5 rounded-full bg-[var(--olive)]" />
          A calm household hub
        </span>

        <h1
          data-testid="hero-heading"
          className="rise rise-1 mt-7 font-display text-5xl font-semibold leading-[1.05] tracking-tight text-[var(--ink)] sm:text-6xl lg:text-7xl"
        >
          Your whole home,
          <br />
          <em className="text-[var(--olive)]">quietly organised.</em>
        </h1>

        <p className="rise rise-2 mt-7 max-w-xl text-lg leading-relaxed text-[var(--ink-soft)]">
          Domaya keeps your pantry, shopping, routines, care tasks and home
          maintenance in one simple, peaceful place. Scan your pantry with AI,
          stay on top of reminders, and let your household run itself.
        </p>

        <div className="rise rise-3 mt-10">
          <StoreBadges />
        </div>
      </div>

      <div className="relative mx-auto flex items-end justify-center">
        <Phone
          src={ASSETS.screenPantry}
          alt="Domaya pantry screen"
          testId="hero-phone-back"
          className="hidden w-52 -rotate-6 translate-y-10 opacity-90 sm:block lg:w-56"
        />
        <Phone
          src={ASSETS.screenToday}
          alt="Domaya today screen"
          testId="hero-phone-front"
          className="z-10 -ml-10 w-64 rotate-2 lg:w-72"
        />
      </div>
    </div>
  </section>
);
